import React from 'react';
import PropTypes from 'prop-types';

import icons from '../../../../data/icons';

import { PAGE_OFFER } from '../../../../config/pages';
import Link from '../../../helpers/Link';

const API_URL = process.env.REACT_APP_CMS;

const OfferDetailsHeader = ({
    t, openPage, language, item
}) => (
    <div className="offer-details-header">
        <Link
          openPage={ openPage }
          language={ language }
          page={ PAGE_OFFER }
          className="offer-details-back"
          id="offer-details-back"
        >
            <span className="offer-details-back-icon" id="offer-details-back-icon" dangerouslySetInnerHTML={ { __html: icons.offer.arrowLeft } }/>
            <span className="offer-details-back-label" id="offer-details-back-label">{ t('offer.general.back') }</span>
        </Link>
        <span className="offer-details-header-icon">
            <img className="offer-details-icon-src" src={ `${ API_URL }/assets/${ item.icon }` } alt={ item.translations.name }/>
        </span>
        <h1 className="offer-details-header-title">{ item.translations.name }</h1>
        <h2 className="offer-details-header-subtitle">{ item.translations.short_description }</h2>
    </div>
);

OfferDetailsHeader.propTypes = {
    t: PropTypes.func.isRequired,
    openPage: PropTypes.func.isRequired,
    language: PropTypes.string.isRequired,
    item: PropTypes.shape().isRequired
};

export default OfferDetailsHeader;



// WEBPACK FOOTER //
// ./src/components/content/offer/details/OfferDetailsHeader.jsx